<template>
    <div style="text-align: center;margin-top: 100px;">
      <div style="line-height: 30px;font-size: 15px;">
        <van-icon name="warn-o" style="margin-right: 5px;" size="18px"></van-icon>抱歉！服务器有点儿问题，请稍后再试!
      </div>
      <van-button size="small" type="danger" style="margin:30px auto;display: block; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)" @click="refreshPage">刷新</van-button>
    </div>
</template>

<script>
  import {getCookie,setCookie,delCookie} from "@/store/cookie";

  export default {
    name: "sign-fail-page",
    data:function () {
      return {

      }
    },
    methods:{
      refreshPage:function () {
        setCookie("trycount",0);
        this.$router.replace({name:"月视图"})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/SignFailPage.vue